import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RellenoService } from 'src/app/services/relleno.service';
import Swal from 'sweetalert2';
import { MatTableDataSource } from '@angular/material/table';

export interface Material {
  sku: string;
  nombre: string;
  cantidadOrigen: number;
  cantidadDestino: number;
  id_rack_m_origen: number;
  id_rack_m_destino: number;
  selected: boolean;
  transferir: number;
  tipo: string;
  id_mat_camp_o: number;
  id_campana: number;
  id_rack_material: number
}

@Component({
  selector: 'app-relleno-mov-inv',
  templateUrl: './relleno-mov-inv.component.html',
  styleUrls: ['./relleno-mov-inv.component.scss']
})
export class RellenoMovInvComponent {

  dataMat: any;
  tipoMovimiento = 'linea';
  lineaOrigen = '';
  lineaDestino = '';
  estacionOrigen = 'all';
  estacionDestino = 'all';
  columnas = ['select', 'material', 'origen', 'destino', 'transferir'];
  estacionesOrigen: {estacion: string}[] = [];
  estacionesDestino: {estacion: string}[] = [];
  materialesCoincidencias: Material[] = [];
  materialesFiltrados: Material[] = [];
  lineaInv = '';
  estacionInv = '';
  estacionesInv: {estacion: string}[] = [];
  tituloOrigen = 'Cantidad origen';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private rellenoServ: RellenoService,
    private dialogRef: MatDialogRef<RellenoMovInvComponent>,
  ) { }

  ngOnInit(): void {
    this.dataMat = this.data;
    this.lineaOrigen = this.dataMat.line;
    this.estacionesOrigen = this.dataMat.objEstaciones.filter( (item: any) => item.line == this.dataMat.line && item.comparte == null);
  }

  changeLineaOrigen(event: any) {
    this.estacionesOrigen = this.dataMat.objEstaciones.filter( (item: any) => item.line == event.value && item.comparte == null);
    this.estacionOrigen = 'all';

    const materialesOrigen = this.dataMat.dataObj.filter( (item: any) => item.line == event.value);
    const materialesDestino = this.dataMat.dataObj.filter( (item: any) => item.line == this.lineaDestino);

    this.materialesCoincidencias = materialesOrigen
    .filter((origen: any) =>
      materialesDestino.some(
        (destino: any) => destino.sku === origen.sku && destino.nombre_comparte == null
      )
    )
    .map((origen: any) => {
      const destino = materialesDestino.find(
        (d: any) => d.sku === origen.sku && d.nombre_comparte == null
      );

      return {
        sku: origen.sku,
        nombre: origen.nombre_mat,
        cantidadOrigen: origen.cantidad,
        cantidadDestino: destino?.cantidad ?? 0,
        id_rack_m_origen: origen.id_rack_material,
        id_rack_m_destino: destino?.id_rack_material,
        selected: false,
        transferir: 0,
        tipo: origen.tipo,
        id_mat_camp_o: origen.id_mat_camp,
        id_campana: origen.id_campana
      };
    });

    this.materialesFiltrados = [...this.materialesCoincidencias];

  }

  changeLineaDestino(event: any) {
    this.estacionesDestino = this.dataMat.objEstaciones.filter( (item: any) => item.line == event.value && item.comparte == null);
    this.estacionDestino = 'all';

    const materialesOrigen = this.dataMat.dataObj.filter( (item: any) => item.line == this.lineaOrigen);
    const materialesDestino = this.dataMat.dataObj.filter( (item: any) => item.line == event.value);

    this.materialesCoincidencias = materialesOrigen
    .filter((origen: any) =>
      materialesDestino.some(
        (destino: any) => destino.sku === origen.sku && destino.nombre_comparte == null
      )
    )
    .map((origen: any) => {
      const destino = materialesDestino.find(
        (d: any) => d.sku === origen.sku && d.nombre_comparte == null
      );

      return {
        sku: origen.sku,
        nombre: origen.nombre_mat,
        cantidadOrigen: origen.cantidad,
        cantidadDestino: destino?.cantidad ?? 0,
        id_rack_m_origen: origen.id_rack_material,
        id_rack_m_destino: destino?.id_rack_material,
        selected: false,
        transferir: 0,
        tipo: origen.tipo,
        id_mat_camp_o: origen.id_mat_camp,
        id_campana: origen.id_campana
      };
    });

    this.materialesFiltrados = [...this.materialesCoincidencias];

  }

  changeEstacionOrigen(event: any) {

    let materialesDestino: any;

    if(this.estacionDestino == 'all'){
      materialesDestino = this.dataMat.dataObj.filter( (item: any) => item.line == this.lineaDestino);
    }
    else{
      materialesDestino = this.dataMat.dataObj.filter( (item: any) => item.estacion == this.estacionDestino);
    }
   
    const materialesOrigen = this.dataMat.dataObj.filter( (item: any) => item.estacion == event.value);

    this.materialesCoincidencias = materialesOrigen
    .filter((origen: any) =>
      materialesDestino.some(
        (destino: any) => destino.sku === origen.sku && destino.nombre_comparte == null
      )
    )
    .map((origen: any) => {
      const destino = materialesDestino.find(
        (d: any) => d.sku === origen.sku && d.nombre_comparte == null
      );

      return {
        sku: origen.sku,
        nombre: origen.nombre_mat,
        cantidadOrigen: origen.cantidad,
        cantidadDestino: destino?.cantidad ?? 0,
        id_rack_m_origen: origen.id_rack_material,
        id_rack_m_destino: destino?.id_rack_material,
        selected: false,
        transferir: 0,
        tipo: origen.tipo,
        id_mat_camp_o: origen.id_mat_camp,
        id_campana: origen.id_campana
      };
    });

    this.materialesFiltrados = [...this.materialesCoincidencias];

  }

  changeEstacionDestino(event: any) {

    let materialesOrigen: any;

    if(this.estacionOrigen == 'all'){
      materialesOrigen = this.dataMat.dataObj.filter( (item: any) => item.line == this.lineaOrigen);
    }
    else{
      materialesOrigen = this.dataMat.dataObj.filter( (item: any) => item.estacion == this.estacionOrigen);
    }

    const materialesDestino = this.dataMat.dataObj.filter( (item: any) => item.estacion == event.value);

    this.materialesCoincidencias = materialesOrigen
    .filter((origen: any) =>
      materialesDestino.some(
        (destino: any) => destino.sku === origen.sku && destino.nombre_comparte == null
      )
    )
    .map((origen: any) => {
      const destino = materialesDestino.find(
        (d: any) => d.sku === origen.sku && d.nombre_comparte == null
      );

      return {
        sku: origen.sku,
        nombre: origen.nombre_mat,
        cantidadOrigen: origen.cantidad,
        cantidadDestino: destino?.cantidad ?? 0,
        id_rack_m_origen: origen.id_rack_material,
        id_rack_m_destino: destino?.id_rack_material,
        selected: false,
        transferir: 0,
        tipo: origen.tipo,
        id_mat_camp_o: origen.id_mat_camp,
        id_campana: origen.id_campana
      };
    });

    this.materialesFiltrados = [...this.materialesCoincidencias];

  }

  saveMovimiento(){

    const seleccionados = this.materialesFiltrados.filter(r => r.selected);

    if (seleccionados.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Selecciona al menos un material para transferir'
      });
      return;
    }

    for (const row of seleccionados) {

      if(this.tipoMovimiento == 'linea'){
        if (!row.transferir || row.transferir <= 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Cantidad inválida',
            text: `La cantidad a transferir debe ser mayor a 0 para el material ${row.nombre}`
          });
          return;
        }

        if (row.transferir > row.cantidadOrigen) {
          Swal.fire({
            icon: 'warning',
            title: 'Cantidad excedida',
            text: `No puedes transferir más de ${row.cantidadOrigen} unidades del material ${row.nombre}`
          });
          return;
        }
      }
      
    }

    const dataSend = seleccionados.map(row => ({
        sku: row.sku,
        material: row.nombre,
        cantidadOrigen: row.cantidadOrigen,
        cantidadDestino: row.cantidadDestino,
        id_rack_m_origen: row.id_rack_m_origen,
        id_rack_m_destino: row.id_rack_m_destino,
        transferir: row.transferir,
        tipo: row.tipo,
        id_mat_camp_o: row.id_mat_camp_o,
        id_campana: row.id_campana,
        id_rack_material: row?.id_rack_material,
        tipoMovimiento: this.tipoMovimiento
    }));

   

    let objData = {
      dataSend,
      tipoMovimiento: this.tipoMovimiento
    };

      this.rellenoServ.saveMovInv(objData).subscribe(
        (result: any) => {
          Swal.fire({
            icon: 'success',
            title: 'Guardado',
            text: ''
          }).then(() => {
            this.dialogRef.close({ reload: true });
          });
        },
        (err: any) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al guardar',
            text: 'Ocurrió un error al guardar'
          });
        }
      );
    

    

  }

  //Para el check general
  isAllSelected(): boolean {
    return this.materialesCoincidencias.length > 0 &&
      this.materialesCoincidencias.every(row => row.selected);
  }

  isIndeterminate(): boolean {
    const seleccionados = this.materialesCoincidencias.filter(r => r.selected).length;
    return seleccionados > 0 && seleccionados < this.materialesCoincidencias.length;
  }

  toggleAll(event: any): void {
    const checked = event.checked;
    this.materialesCoincidencias.forEach(row => {
      row.selected = checked;
    });
  }

  filtrarMateriales(event: Event) {
  const valor = (event.target as HTMLInputElement).value.toLowerCase().trim();

  if (!valor) {
    this.materialesFiltrados = [...this.materialesCoincidencias];
    return;
  }

  this.materialesFiltrados = this.materialesCoincidencias.filter(material =>
    material.nombre.toLowerCase().includes(valor)
  );
}

changeTipoMovimiento(event: any){
  this.tipoMovimiento = event.value; 

  if (event.value === 'inv') {
    this.columnas = [
      'select',
      'material',
      'origen'
    ];
    this.tituloOrigen = 'Cantidad a devolver';
  } else {
    this.columnas = [
      'select',
      'material',
      'origen',
      'destino',
      'transferir'
    ];
    this.tituloOrigen = 'Cantidad origen';
  }
}

changeLineaInv(event: any) {
    this.estacionesInv = this.dataMat.objEstaciones.filter( (item: any) => item.line == event.value);
    this.estacionInv = 'all';

    let materialesE: any;
    materialesE = this.dataMat.dataObj.filter( (item: any) => item.line == this.lineaInv);

      this.materialesCoincidencias = materialesE.map( (mat:any) => {

            return {
              sku: mat.sku,
              nombre: mat.nombre_mat,
              cantidadOrigen: mat.cantidad,
              cantidadDestino: 0,
              id_rack_m_origen: 0,
              id_rack_m_destino: 0,
              selected: false,
              transferir: 0,
              id_rack_material: mat.id_rack_material,
              tipo: mat.tipo,
              id_mat_camp_o: mat.id_mat_camp,
              id_campana: mat.id_campana
            };

          })

      this.materialesFiltrados = [...this.materialesCoincidencias];
  }

  changeEstacionInv(event: any) {

    let materialesE: any;

    if(this.estacionInv == 'all'){
      materialesE = this.dataMat.dataObj.filter( (item: any) => item.line == this.lineaInv);
    }
    else{
      materialesE = this.dataMat.dataObj.filter( (item: any) => item.estacion == event.value);
    }

    this.materialesCoincidencias = materialesE.map( (mat:any) => {

      return {
        sku: mat.sku,
        nombre: mat.nombre_mat,
        cantidadOrigen: mat.cantidad,
        cantidadDestino: 0,
        id_rack_m_origen: 0,
        id_rack_m_destino: 0,
        selected: false,
        transferir: 0,
        id_rack_material: mat.id_rack_material,
        tipo: mat.tipo,
        id_mat_camp_o: mat.id_mat_camp,
        id_campana: mat.id_campana
      };

    })

    this.materialesFiltrados = [...this.materialesCoincidencias];
 

  }

}
